import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useNotificationCounts() {
  const [counts, setCounts] = useState({ activity: 0, messages: 0, documents: 0, quickPay: 0, announcements: 0, itemsNeeded: 0, artwork: 0, menus: 0 });

  const fetchCounts = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/parent-communication/parent/notifications/count`);
      setCounts(res.data);
    } catch { /* silent */ }
  }, []);

  const markSeen = useCallback(async (section) => {
    try {
      await axios.post(`${API}/parent-communication/parent/notifications/mark-seen`, { section });
      setCounts((prev) => ({ ...prev, [section]: 0 }));
    } catch { /* silent */ }
  }, []);

  useEffect(() => {
    fetchCounts();
    const interval = setInterval(fetchCounts, 30000); // Poll every 30s
    return () => clearInterval(interval);
  }, [fetchCounts]);

  return { counts, markSeen };
}
